<template>
  <div>
    <div class="pc header">
      <div>
        <div style="width: 1500px" class="flex-center main-content">
          <img
            :src="basicInfo.head_logo"
            alt=""
            class="logo typeClick"
            @click="handleSelect(`home`)"
          />
          <div style="flex: 1"></div>
          <img
            src="@/assets/phone.png"
            alt=""
            style="width: 50px"
            v-show="!scarch.value"
          />
          <div style="font-size: 20px; padding: 0 10px" v-show="!scarch.value">
            <div>24h资讯服务电话</div>
            <div>{{ basicInfo.phone || "" }}</div>
          </div>
          <el-input
            v-model="scarch.content"
            v-show="scarch.value"
            style="width: 200px; margin-right: 20px"
          ></el-input>
          <div style="width: 1px; height: 35px; background: #000"></div>
          <img
            src="@/assets/fdj.png"
            alt=""
            style="width: 40px; padding: 0 10px"
          />
        </div>
      </div>
      <div>
        <div style="background: #333">
          <ul
            class="el-menu-demo el-menu"
            :style="`margin: ${navBarFixed == true ? '0' : '20'}px auto 0px; `"
          >
            <li class="menu-li" v-for="(item, index) of menuList" :key="index">
              <div
                :class="`${
                  [item.name].indexOf(activeIndex) !== -1 || getShow(index)
                    ? 'actionSelect'
                    : ''
                }`"
                @click="handleSelect(item.name)"
              >
                {{ item.title || ""
                }}<i
                  class="el-submenu__icon-arrow"
                  :class="`el-icon-arrow-up`"
                  style="color: #fff"
                  v-if="item.children"
                ></i>
              </div>
              <ul class="nav-menu" v-if="item.children">
                <li
                  v-for="(items, indexs) of item.children"
                  :key="indexs"
                  :class="`${
                    [items.name].indexOf(activeIndex) !== -1
                      ? 'actionSelect'
                      : ''
                  }`"
                  @click="handleSelect(items.name)"
                >
                  {{ items.title || "" }}
                </li>
              </ul>
            </li>
            <!-- @mouseenter="mouseEnter" @mouseout="mouseOut" -->
          </ul>
        </div>
        <div
          style="background: #fff"
          class="flex-center"
          :class="navBarFixed == true ? 'navBarWrap' : 'hideFixed'"
        >
          <img
            :src="basicInfo.head_logo"
            alt=""
            class="typeClick"
            style="width: 260px; padding: 10px 20px; margin: 0 50px 0 200px"
            @click="handleSelect(`home`)"
          />
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo1"
            mode="horizontal"
            @select="handleSelect"
            active-text-color="#439392"
            style="margin-right: 200px"
          >
            <template v-for="(item, index) of menuList">
              <el-menu-item
                :index="item.name"
                :style="`width: calc(100% / ${menuList.length})`"
                :key="index"
                v-if="!item.children"
              >
                {{ item.title }}
              </el-menu-item>
              <el-submenu
                index="about"
                :style="`width: calc(100% / ${menuList.length})`"
                :key="index"
                v-if="item.children"
              >
                <template slot="title">{{ item.title }}</template>
                <el-menu-item
                  :index="items.name"
                  class="ft13"
                  v-for="(items, indexs) of item.children"
                  :key="indexs"
                  >{{ items.title }}</el-menu-item
                >
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </div>
      <!-- <el-input v-model="zxc" style="width:100px;" size="small"></el-input> -->
    </div>
    <div class="mobile header">
      <div class="flex-center">
        <div style="flex: 1; text-align: left" @click="handleSelect(`home`)">
          <img src="../assets/mobile/logo.png" alt="" style="height: 0.5rem" />
        </div>
        <div style="font-size: 20px; color: #fff">
          <img
            src="../assets/icon13.png"
            @click="show = true"
            alt=""
            style="width: 0.3rem"
          />
        </div>
      </div>
      <van-popup
        v-model="show"
        position="right"
        :style="{ height: '100%' }" 
        style="z-index:200000;"
        get-container=".swipe-bg"
      >
        <div
          style="
            width: 2.5rem;
            text-align: center;
            min-height: 0.5rem;
            line-height: 0.5rem;
            border-bottom: 1px solid #e5e5e5;
            font-size: 0.17rem;
            position: relative;
          "
          :style="
            menuName === item.name
              ? `
            background:#439392;
            color:#fff;`
              : ``
          "
          v-for="(item, index) of mMenulist"
          :key="index"
          @click="goAppPage(item, item.name)"
        >
          {{ item.title }}
          <div
            style="position: absolute; right: 10px; top: 0"
            v-if="item.children"
          >
            <i class="el-icon-arrow-up" v-if="menuName === item.name"></i>
            <i class="el-icon-arrow-down" v-else></i>
          </div>
          <!-- && menuName === item.name -->
          <template>
            <div
              class="menuChildren"
              :class="`class${item.name}`"
              v-show="item.children && menuName === item.name"
            >
              <div
                @click="goAppPage(items, indexs)"
                v-for="(items, indexs) of item.children"
                :key="indexs"
              >
                {{ items.title || items.main_title }}
              </div>
            </div>
          </template>
        </div>
      </van-popup>
      <BottomBar  :active="activeIndex" style="z-index:999999;"></BottomBar>
    </div>
    <RightBar></RightBar>
  </div>
</template>

<script>
import { menulist, getsite, mMenulist } from "@/api/common";
import $ from "jquery";
import BottomBar from './bottomBar.vue';
export default {
  components: { BottomBar },
  name: "Header",
  data() {
    return {
      navBarFixed: false,
      nowHoven: "",
      menuName: "",
      menuList: [],
      mMenulist: [],
      basicInfo: {
        head_logo: "",
      },
      scarch: {
        value: false,
        content: "",
      },
      a: "",
      show: false,
    };
  },
  props: {
    activeIndex: {
      type: String,
      default: this.a,
    },
  },
  mounted() {
    this.a = this.getwg();
    this.getmenulist();
    this.getBasicInfo();
    window.addEventListener("scroll", this.watchScroll);
  },
  methods: {
    getmenulist() {
      //获取pc端菜单
      if (this.saveMenuList() === null) {
        menulist().then((res) => {
          this.menuList = res.data;
          this.saveMenuList(res.data);
        });
      } else {
        this.menuList = this.saveMenuList();
      }

      //获取手机端菜单
      if (this.saveMenuList1() === null) {
        mMenulist().then((res) => {
          this.mMenulist = res.data;
          this.saveMenuList1(res.data);
        });
      } else {
        this.mMenulist = this.saveMenuList1();
      }
    },
    getBasicInfo() {
      if (this.saveBasicInfo() === null || !this.saveBasicInfo().name) {
        getsite().then((res) => {
          this.basicInfo = res.data;
          this.saveBasicInfo(res.data);
        });
      } else {
        this.basicInfo = this.saveBasicInfo();
      }
    },
    // saveBasicInfo
    showLi(name) {
      this.nowHoven = name;
    },
    hideLi() {
      this.nowHoven = "";
    },
    handleSelect(name, index) {
      this.activeIndex = name;
      this.getwg(name);
      if (index) {
      }
      this.$router.push({ name }).catch(() => {
          this.backtopClick()
          this.show = false
      });
    },
    
    backtopClick() {
      $('body,html').animate({scrollTop:0},1000);
      return false;
    },
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 90 时，实现吸顶效果
      if (scrollTop > 180) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    getShow(index) {
      if (this.menuList[index].children) {
        var a = [];
        this.menuList[index].children.forEach((item) => {
          a.push(item.name);
        });
        if (a.indexOf(this.activeIndex) !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    goAppPage(item, name) {
      if (item.children) {
        if (this.menuName !== item.name) {
          this.menuName = item.name;
          $(`.class${name}`).slideDown("fast");
        } else if (this.menuName === item.name) {
          $(`.class${name}`).slideUp("fast");
          var that = this;
          setTimeout(() => {
            that.menuName = "";
          }, 200);
        }
      } else if (item.name) {
        this.handleSelect(item.name);
      } else {
        this.handleSelect(this.menuName, name);
      }
    },
  },
};
</script>
<style>
li {
  list-style: none;
}

.el-menu-demo {
  width: 1600px;
  background: #333 !important;
  border: 0 !important;
  flex: 1;
  text-align: center;
  margin-right: 100px;
}
.menu-li {
  float: left;
  width: calc(100% / 6);
  font-size: 18px;
  color: #dfd7d8;
  padding: 0;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}
.menu-li .nav-tab {
  height: 80px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 80px;
  font-weight: 400;
  position: relative;
}
.menu-li .nav-menu {
  width: 100%;
  height: 0px;
  padding: 0;
  float: left;
  position: absolute;
  display: block;
  background: #fff;
  color: #439392;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0 0 2px 2px;
  overflow: hidden;
  z-index: 999;
  /* // 让li的内容隐藏，实现从上往下显示的效果 */
}
.menu-li .nav-menu li {
  height: 55px;
  border-bottom: 1px solid #eeeeee;
  font-size: 14px;
  line-height: 55px;
  text-align: center;
  width: 100%;
  font-weight: 400;
  position: relative;
}
.actionSelect {
  background: #439392;
  color: #fff;
}
.nav-menu li:hover {
  /* background: #439392;
  color: #fff; */
}
.menu-li .nav-menu li:after,
.menu-li:after {
  content: "";
  width: 0;
  height: 2px;
  background: #439392;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease 0s;
}
.menu-li .nav-menu li:hover:after,
.menu-li:hover:after {
  width: 100%;
}
.menu-li:hover .nav-menu {
  transition: all 0.5s;
  /* // 鼠标移出时menu瞬间消失，故将transition加在hover里 */
  height: 165px;
  /* // 使menu的高度从0到275px，配合transition实现平滑滑下的动画效果 */
  padding-bottom: 3px;
}
.menu-li .el-submenu__icon-arrow {
  position: static;
  margin-left: 10px;
  color: #909399;
  transform: rotateZ(180deg);
}
.showLi {
  color: #333;
  transition: all 0.3s;
}
.navBarWrap {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  box-shadow: rgb(102 102 102) 0px 0px 10px;
}
.hideFixed {
  display: none;
}
.header {
  background-image: linear-gradient(rgba(0, 148, 94, 0.2), rgba(0, 148, 94, 0));
  padding: 20px 0px 0px;
}
.header .main-content {
  margin: 0 auto 20px;
}
.header .el-menu-demo1 {
  background: #fff !important;
  border: 0 !important;
  flex: 1;
  text-align: center;
  margin-right: 100px;
}
.header .el-menu-demo > .el-menu-item.is-active {
  background: #439392 !important;
  color: #fff !important;
}
.header .el-menu-demo1 > .el-menu-item.is-active {
  font-weight: bold;
  color: #439392 !important;
  border-bottom: 1px solid #439392;
}

.header .el-menu-demo .el-menu-item,
.header .el-menu-demo .el-submenu__title {
  padding: 0;
  font-size: 22px;
  color: #dfd7d8 !important;
}
.header .el-menu-demo1 .el-menu-item,
.header .el-menu-demo1 .el-submenu__title {
  padding: 0;
  font-size: 20px;
  color: #666 !important;
}

.header .el-menu-demo1 .el-menu-item,
.header .el-menu-demo1 .el-submenu__title {
  padding: 0;
  font-size: 20px;
  color: #666 !important;
}

.header .el-menu-demo .el-menu-item:hover,
.header .el-menu-demo .el-submenu__title:hover {
  background: #439392 !important;
  color: #fff !important;
}

.header .el-menu-item:hover,
.header .el-submenu__title:hover {
  color: #439392 !important;
  border-bottom: 1px solid #439392;
}
.el-menu-demo1 .el-menu-item:after,
.el-menu-demo1 .el-submenu__title:after {
  content: "";
  width: 0;
  height: 2px;
  background: #439392;
  position: absolute;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease 0s;
}
.el-menu-demo1 .el-menu-item:hover:after,
.el-menu-demo1 .el-submenu__title:hover:after {
  width: 100%;
}
.el-menu--horizontal .el-menu .el-menu-item:hover {
  color: #439392 !important;
}
.header .el-menu--horizontal > .el-menu-item,
.header .el-menu--horizontal .el-submenu__title {
  height: 80px !important;
  line-height: 80px !important;
}
@media screen and (max-width: 750px) {
  .header {
    padding: 0.1rem 0.2rem;
    background: #439392;
  }
  .menuChildren div {
    width: 2.5rem;
    height: 0.5rem;
    line-height: 0.5rem;
    border-top: 1px solid #e5e5e5;
    background: #4da88a;
    transition: all 1s;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue